var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 11.1663H2.33268V11.583H1.49935V12.4163H2.33268V12.833H0.666016V13.6663H3.16602V10.333H0.666016V11.1663ZM1.49935 3.66634H2.33268V0.333008H0.666016V1.16634H1.49935V3.66634ZM0.666016 6.16634H2.16602L0.666016 7.91634V8.66634H3.16602V7.83301H1.66602L3.16602 6.08301V5.33301H0.666016V6.16634ZM4.83268 1.16634V2.83301H16.4993V1.16634H4.83268ZM4.83268 12.833H16.4993V11.1663H4.83268V12.833ZM4.83268 7.83301H16.4993V6.16634H4.83268V7.83301Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.c0136605822dc1e30d402d0e1652280d.svg";
export { ForwardRef as ReactComponent };